var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHgtv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 710.1 361.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2cbb9f;}.cls-2{fill:#004667;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.59,123.67l24,20.27L580.64,156s23-7.78,23.64-5.42-1.83,22.3-1.83,22.3h11.71s-1.93-19.29-1.86-22.29,23.64,5.36,23.64,5.36L634,143.89l23.92-20.32s-5.22-.83-6.52-2.3,5.3-18.18,5.3-18.18-14.16,4.86-15.63,4.26-1.62-9.5-1.62-9.5-14.56,20.43-17.09,18.36,6.26-35.95,6.26-35.95-9.34,8.91-11,8.92-9.45-21.46-9.45-21.46-7.58,21.15-9.4,21.48-11-8.89-11-8.89,8.64,33.56,6.34,35.93S577,97.92,577,97.92s-.26,8.55-1.59,9.49-15.65-4.22-15.65-4.22,6.45,16.43,5.36,18.17S558.59,123.67,558.59,123.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.68 0 0 158.6 490.67 158.6 245.68 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.58 237.55 62.71 237.55 62.71 171.91 0.52 171.91 0.52 357.94 62.71 357.94 62.71 291.24 119.58 291.24 119.58 357.94 181.76 357.94 181.76 171.91 119.58 171.91 119.58 237.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.17,287.27h31.89v18.6c-4.78,2.66-10.63,4.25-21.26,4.25-26,0-44.38-18.07-44.38-44.38v-.53c0-25.25,17.54-43.85,41.73-43.85,15.41,0,29,5.85,41.19,16.21l34.81-42c-20.2-17.54-46-28.17-77.86-28.17-58.73,0-102.58,41.45-102.58,97v.52c0,57.67,46.5,96.48,104.44,96.48,33.75,0,61.92-11.43,82.11-27.91v-86.1H289.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "641.54 171.4 605.39 275.84 569.25 171.4 547.87 171.4 499.63 171.4 376.19 171.4 376.19 224.02 430.94 224.02 430.94 357.43 493.13 357.43 493.13 224.02 520.82 224.02 575.1 358.76 634.63 358.76 710.1 171.4 641.54 171.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M558.59,123.67l24,20.27L580.64,156s23-7.78,23.64-5.42-1.83,22.3-1.83,22.3h11.71s-1.93-19.29-1.86-22.29,23.64,5.36,23.64,5.36L634,143.89l23.92-20.32s-5.22-.83-6.52-2.3,5.3-18.18,5.3-18.18-14.16,4.86-15.63,4.26-1.62-9.5-1.62-9.5-14.56,20.43-17.09,18.36,6.26-35.95,6.26-35.95-9.34,8.91-11,8.92-9.45-21.46-9.45-21.46-7.58,21.15-9.4,21.48-11-8.89-11-8.89,8.64,33.56,6.34,35.93S577,97.92,577,97.92s-.26,8.55-1.59,9.49-15.65-4.22-15.65-4.22,6.45,16.43,5.36,18.17S558.59,123.67,558.59,123.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "245.68 0 0 158.6 490.67 158.6 245.68 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.58 237.55 62.71 237.55 62.71 171.91 0.52 171.91 0.52 357.94 62.71 357.94 62.71 291.24 119.58 291.24 119.58 357.94 181.76 357.94 181.76 171.91 119.58 171.91 119.58 237.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.17,287.27h31.89v18.6c-4.78,2.66-10.63,4.25-21.26,4.25-26,0-44.38-18.07-44.38-44.38v-.53c0-25.25,17.54-43.85,41.73-43.85,15.41,0,29,5.85,41.19,16.21l34.81-42c-20.2-17.54-46-28.17-77.86-28.17-58.73,0-102.58,41.45-102.58,97v.52c0,57.67,46.5,96.48,104.44,96.48,33.75,0,61.92-11.43,82.11-27.91v-86.1H289.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "641.54 171.4 605.39 275.84 569.25 171.4 547.87 171.4 499.63 171.4 376.19 171.4 376.19 224.02 430.94 224.02 430.94 357.43 493.13 357.43 493.13 224.02 520.82 224.02 575.1 358.76 634.63 358.76 710.1 171.4 641.54 171.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHgtv);
export default __webpack_public_path__ + "static/media/HGTV.a281640fda517d7708479aaa77b5af48.svg";
export { ForwardRef as ReactComponent };